import { render, staticRenderFns } from "./canPublishPlatform.vue?vue&type=template&id=c2aa5da2&scoped=true"
import script from "./canPublishPlatform.vue?vue&type=script&lang=js"
export * from "./canPublishPlatform.vue?vue&type=script&lang=js"
import style0 from "./canPublishPlatform.vue?vue&type=style&index=0&id=c2aa5da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aa5da2",
  null
  
)

export default component.exports